import { FunctionComponent } from "react";
import * as Styled from "./styles";

interface VectorWrapperProps {
  imgSrc: string;
  webpSrc: string;
  imgAlt: string;
  name: string;
}

const VectorWrapper: FunctionComponent<VectorWrapperProps> = ({
  imgSrc,
  imgAlt,
  name,
  webpSrc,
}: VectorWrapperProps) => {
  return (
    <Styled.VectorWrapperDiv data-name={name}>
      <picture>
        <source srcSet={webpSrc} />
        <img src={imgSrc} alt={imgAlt} />
      </picture>
    </Styled.VectorWrapperDiv>
  );
};

export default VectorWrapper;
